import * as actionTypes from '../../actions/action-types.js'
const initialState = {
    lastFetch: 0,
    loading: false,
}
const assetTypes = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FD_ASSTYP_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                lastFetch: Date.now(),
                data: action.data,
            }
        case actionTypes.FD_ASSTYP_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.FD_ASSTYP_REQUEST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
                lastError: Date.now(),
            }
        case actionTypes.FD_ASSTYP_CACHE:
            return state
        default: {
            return state
        }
    }
}

export default assetTypes
